import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import OpacityIcon from "@mui/icons-material/Opacity";

const HumidityDetail1Widget = ({ widget, onValueUpdate }) => {
  const [humidity, setHumidity] = useState(0);
  const [isFlashing, setIsFlashing] = useState(false);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const value = Number(widget.items.$w1.value);
      setHumidity(isNaN(value) ? 0 : value);
      setIsFlashing(true);
      setTimeout(() => setIsFlashing(false), 500);
    }
  }, [widget]);

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Humidity Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-500"
        style={{
          height: "40px",
          backgroundColor: isFlashing
            ? "hsl(var(--primary))"
            : "hsl(var(--primary) / 0.8)",
        }}
      >
        <Typography className="text-white font-bold text-lg">
          {humidity.toFixed(1)} %
        </Typography>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          <OpacityIcon style={{ fontSize: "1.5rem", color: "white" }} />
        </div>
      </div>
    </div>
  );
};

export default HumidityDetail1Widget;
